import { useEffect, useState } from 'react'
import { getLeaders as getLeadersApi, Leader } from 'web-api-client'

const useLeaders = (): { leaders: Leader[]; isFetching: boolean } => {
  const [leaders, setLeaders] = useState<Leader[]>([])
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const getLeaders = async () => {
    setIsFetching(true)
    try {
      const leaders = await getLeadersApi()

      setLeaders(leaders.items)
    } catch (error) {
      console.log('error', error)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    getLeaders()
  }, [])

  return { leaders, isFetching }
}

export default useLeaders
